module.exports = __webpack_public_path__ + "images/icons_v2/values-own-it-eb49a426.svg";